exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  text-align: justify; }\n\n.flex-item img {\n  padding: 10px 25px; }\n\n@media (min-width: 320px) and (max-width: 480px) {\n  .flex-container {\n    -ms-flex-direction: column;\n        flex-direction: column; }\n    .flex-container.col-2 > .flex-item {\n      width: 100%; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/concept.component.scss
// module id = ../../../../../src/app/pages/concept.component.scss
// module chunks = main